import { ExploreDevelopBase } from './base/explore-develop-base';

export class ExploreDevelop extends ExploreDevelopBase { }